import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconNumber7Circle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="number-7-circle"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><path d="M9.70117 16.25L13.375 9.125V9.03125H9.01562V7.79492H14.8984V9.05469L11.2832 16.25H9.70117Z" fill="currentColor"/></CentralIconBase>;
};

export default IconNumber7Circle;
